import { NavLink } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import { useState } from 'react';
import { cn } from '@/utils/cn';

export function SidebarNavItem({ item, collapsed }) {
  const [open, setOpen] = useState(false);
  const hasChildren = Array.isArray(item.children) && item.children.length > 0;

  if (hasChildren) {
    return (
      <div>
        <button
          type="button"
          className={cn(
            'flex w-full items-center gap-3 rounded-md px-3 py-2 text-sm text-[var(--sidebar-foreground)] hover:bg-[var(--sidebar-muted)]',
            collapsed && 'justify-center px-2',
          )}
          onClick={() => setOpen((value) => !value)}
          aria-expanded={open}
        >
          {item.icon ? <item.icon size={18} aria-hidden /> : null}
          {!collapsed ? (
            <>
              <span className="flex-1 text-left">{item.label}</span>
              <ChevronDown size={16} className={cn('transition', open && 'rotate-180')} />
            </>
          ) : null}
        </button>
        {!collapsed && open ? (
          <div className="ml-4 mt-1 space-y-1 border-l border-white/10 pl-2">
            {item.children.map((child) => (
              <SidebarNavItem key={child.to || child.label} item={child} collapsed={false} />
            ))}
          </div>
        ) : null}
      </div>
    );
  }

  return (
    <NavLink
      to={item.to}
      className={({ isActive }) =>
        cn(
          'flex items-center gap-3 rounded-md px-3 py-2 text-sm text-[var(--sidebar-foreground)] hover:bg-[var(--sidebar-muted)]',
          isActive && 'bg-[var(--sidebar-muted)] font-medium text-[var(--sidebar-accent)]',
          collapsed && 'justify-center px-2',
        )
      }
      title={collapsed ? item.label : undefined}
    >
      {item.icon ? <item.icon size={18} aria-hidden /> : null}
      {!collapsed ? <span>{item.label}</span> : null}
    </NavLink>
  );
}
